import { AssumptionDefinition, OutputDefinition } from "@/types/excel/types";

const path = (...parts: string[]) => parts.join(".");

export const FULL_DEAL_MAPPING: AssumptionDefinition[] = [
  // ========== PROPERTY DETAILS ==========
  {
    key: path("name"),
    label: "Deal Name",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D4",
    format: "text",
  },
  {
    key: path("location"),
    label: "Location",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D5",
    format: "text",
  },
  {
    key: path("kpis", "fullAddress"),
    label: "Full Address",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D6",
    format: "text",
  },
  {
    key: path("kpis", "propertyType"),
    label: "Property Type",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D7",
    format: "text",
  },
  {
    key: path("currency"),
    label: "Currency",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D8",
    format: "text",
  },

  // Building Details
  {
    key: path("kpis", "gfaSqm"),
    label: "Building GFA (sqm)",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D10",
    format: "number",
    min: 0,
  },
  {
    key: path("kpis", "stars"),
    label: "Star Rating",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D11",
    format: "number",
    min: 0,
    max: 10,
  },

  // Room Types - 5 types
  {
    key: path("kpis", "roomMix", "0", "name"),
    label: "Room Type 1 Name",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "C14",
    format: "text",
  },
  {
    key: path("kpis", "roomMix", "0", "count"),
    label: "Room Type 1 Count",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "D14",
    format: "number",
    min: 0,
  },
  {
    key: path("kpis", "roomMix", "1", "name"),
    label: "Room Type 2 Name",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "C15",
    format: "text",
  },
  {
    key: path("kpis", "roomMix", "1", "count"),
    label: "Room Type 2 Count",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "D15",
    format: "number",
    min: 0,
  },
  {
    key: path("kpis", "roomMix", "2", "name"),
    label: "Room Type 3 Name",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "C16",
    format: "text",
  },
  {
    key: path("kpis", "roomMix", "2", "count"),
    label: "Room Type 3 Count",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "D16",
    format: "number",
    min: 0,
  },
  {
    key: path("kpis", "roomMix", "3", "name"),
    label: "Room Type 4 Name",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "C17",
    format: "text",
  },
  {
    key: path("kpis", "roomMix", "3", "count"),
    label: "Room Type 4 Count",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "D17",
    format: "number",
    min: 0,
  },
  {
    key: path("kpis", "roomMix", "4", "name"),
    label: "Room Type 5 Name",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "C18",
    format: "text",
  },
  {
    key: path("kpis", "roomMix", "4", "count"),
    label: "Room Type 5 Count",
    section: "Room Mix",
    sheet: "Property Details",
    cell: "D18",
    format: "number",
    min: 0,
  },

  // Total Rooms
  {
    key: path("kpis", "rooms", "total"),
    label: "Total Rooms",
    section: "Property Details",
    sheet: "Property Details",
    cell: "D19",
    format: "number",
    min: 0,
  },

  // Facilities
  {
    key: path("kpis", "property", "facilities", "0"),
    label: "Restaurant",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D23",
    format: "text",
  },
  {
    key: path("kpis", "property", "facilities", "1"),
    label: "Bar",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D24",
    format: "text",
  },
  {
    key: path("kpis", "property", "facilities", "2"),
    label: "Room Service",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D25",
    format: "text",
  },
  {
    key: path("kpis", "property", "facilities", "3"),
    label: "Spa",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D26",
    format: "text",
  },
  {
    key: path("kpis", "property", "facilities", "4"),
    label: "Parking",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D27",
    format: "text",
  },
  {
    key: path("kpis", "property", "facilities", "5"),
    label: "Meeting & Events",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D28",
    format: "text",
  },
  {
    key: path("kpis", "property", "facilities", "6"),
    label: "Pool",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D29",
    format: "text",
  },
  {
    key: path("kpis", "property", "facilities", "7"),
    label: "Gym / Fitness",
    section: "Facilities",
    sheet: "Property Details",
    cell: "D30",
    format: "text",
  },

  // ========== INVESTMENT BUDGET ==========
  {
    key: path("kpis", "investmentBudget", "netPurchasePrice"),
    label: "Net Purchase Price",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D5",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "reTransferTax"),
    label: "Real Estate Transfer Tax",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D6",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "dealCosts"),
    label: "Deal Costs",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D7",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "siteAcquisition"),
    label: "Site Acquisition",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D8",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "constructionCosts"),
    label: "Construction Costs",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D10",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "ffeOse"),
    label: "FF&E and OS&E",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D11",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "professionalFees"),
    label: "Professional Fees",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D14",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "planningCharges"),
    label: "Planning and Municipal Charges",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D15",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "developmentFee"),
    label: "Development Fee",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D16",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "insuranceAdmin"),
    label: "Insurance & Admin Costs",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D19",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "otherDev"),
    label: "Other Costs",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D20",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "preOpening"),
    label: "Pre-Opening Budget",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D23",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "contingencyAmount"),
    label: "Contingency",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D26",
    format: "currency",
  },
  {
    key: path("kpis", "investmentBudget", "grandTotal"),
    label: "Grand Total Excl. VAT",
    section: "Investment Budget",
    sheet: "Investment Budget",
    cell: "D29",
    format: "currency",
  },

  // ========== ROOM REVENUE ==========
  // ADR by month
  {
    key: path("kpis", "roomRev", "adr", "0"),
    label: "ADR January",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E5",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "1"),
    label: "ADR February",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E6",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "2"),
    label: "ADR March",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E7",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "3"),
    label: "ADR April",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E8",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "4"),
    label: "ADR May",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E9",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "5"),
    label: "ADR June",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E10",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "6"),
    label: "ADR July",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E11",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "7"),
    label: "ADR August",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E12",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "8"),
    label: "ADR September",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E13",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "9"),
    label: "ADR October",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E14",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "10"),
    label: "ADR November",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E15",
    format: "currency",
  },
  {
    key: path("kpis", "roomRev", "adr", "11"),
    label: "ADR December",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "E16",
    format: "currency",
  },

  // Occupancy by month
  {
    key: path("kpis", "roomRev", "occ", "0"),
    label: "Occupancy January",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F5",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "1"),
    label: "Occupancy February",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F6",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "2"),
    label: "Occupancy March",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F7",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "3"),
    label: "Occupancy April",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F8",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "4"),
    label: "Occupancy May",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F9",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "5"),
    label: "Occupancy June",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F10",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "6"),
    label: "Occupancy July",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F11",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "7"),
    label: "Occupancy August",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F12",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "8"),
    label: "Occupancy September",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F13",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "9"),
    label: "Occupancy October",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F14",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "10"),
    label: "Occupancy November",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F15",
    format: "percent",
  },
  {
    key: path("kpis", "roomRev", "occ", "11"),
    label: "Occupancy December",
    section: "Room Revenue",
    sheet: "Room Revenue",
    cell: "F16",
    format: "percent",
  },

  // ========== F&B REVENUE ==========
  {
    key: path("kpis", "fnb", "avgGuests"),
    label: "Avg Guests per Room",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "C4",
    format: "number",
  },
  // Breakfast
  {
    key: path("kpis", "fnb", "capture", "breakfast"),
    label: "Breakfast - Guest Capture",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "D8",
    format: "percent",
  },
  {
    key: path("kpis", "fnb", "check", "guest", "breakfast"),
    label: "Breakfast - Guest Avg Check",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "E8",
    format: "currency",
  },
  {
    key: path("kpis", "fnb", "external", "perDay", "breakfast"),
    label: "Breakfast External Cust / Day",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "G8",
    format: "number",
  },
  {
    key: path("kpis", "fnb", "check", "external", "breakfast"),
    label: "Breakfast Avg Check External",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "H8",
    format: "currency",
  },
  // Lunch
  {
    key: path("kpis", "fnb", "capture", "lunch"),
    label: "Lunch - Guest Capture",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "D9",
    format: "percent",
  },
  {
    key: path("kpis", "fnb", "check", "guest", "lunch"),
    label: "Lunch - Guest Avg Check",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "E9",
    format: "currency",
  },
  {
    key: path("kpis", "fnb", "external", "perDay", "lunch"),
    label: "Lunch External Cust / Day",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "G9",
    format: "number",
  },
  {
    key: path("kpis", "fnb", "check", "external", "lunch"),
    label: "Lunch Avg Check External",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "H9",
    format: "currency",
  },
  // Dinner
  {
    key: path("kpis", "fnb", "capture", "dinner"),
    label: "Dinner - Guest Capture",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "D10",
    format: "percent",
  },
  {
    key: path("kpis", "fnb", "check", "guest", "dinner"),
    label: "Dinner - Guest Avg Check",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "E10",
    format: "currency",
  },
  {
    key: path("kpis", "fnb", "external", "perDay", "dinner"),
    label: "Dinner External Cust / Day",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "G10",
    format: "number",
  },
  {
    key: path("kpis", "fnb", "check", "external", "dinner"),
    label: "Dinner Avg Check External",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "H10",
    format: "currency",
  },
  // Bar
  {
    key: path("kpis", "fnb", "capture", "bar"),
    label: "Bar - Guest Capture",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "D11",
    format: "percent",
  },
  {
    key: path("kpis", "fnb", "check", "guest", "bar"),
    label: "Bar - Guest Avg Check",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "E11",
    format: "currency",
  },
  {
    key: path("kpis", "fnb", "external", "perDay", "bar"),
    label: "Bar External Cust / Day",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "G11",
    format: "number",
  },
  {
    key: path("kpis", "fnb", "check", "external", "bar"),
    label: "Bar Avg Check External",
    section: "F&B Revenue",
    sheet: "F&B Revenue",
    cell: "H11",
    format: "currency",
  },

  // ========== OTHER REVENUE ==========
  {
    key: path("kpis", "otherRev", "wellness", "treatmentsPerDay"),
    label: "Spa - Treatments per Day",
    section: "Other Revenue",
    sheet: "Other Revenue",
    cell: "D5",
    format: "number",
  },
  {
    key: path("kpis", "otherRev", "wellness", "avgPrice"),
    label: "Spa - Average Price per Treatment",
    section: "Other Revenue",
    sheet: "Other Revenue",
    cell: "D6",
    format: "currency",
  },
  {
    key: path("kpis", "otherRev", "other", "value"),
    label: "Other Revenue - % of Rooms",
    section: "Other Revenue",
    sheet: "Other Revenue",
    cell: "D12",
    format: "percent",
  },
  {
    key: "kpis.otherRev.other.monthlyFixed",
    label: "Other Revenue - Monthly Fixed",
    section: "Other Revenue",
    sheet: "Other Revenue",
    cell: "D13",
    format: "currency",
  },

  // ========== PAYROLL MODEL - ROOMS DEPARTMENT ==========
  // Role 1
  {
    key: path("kpis", "payroll", "rooms", "role1", "name"),
    label: "Rooms Role 1 Name",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "C8",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "rooms", "role1", "fte"),
    label: "Rooms Role 1 FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D8",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "role1", "salaryPerFte"),
    label: "Rooms Role 1 Salary/FTE",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "E8",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "rooms", "role1", "socialCharges"),
    label: "Rooms Role 1 Social Charges %",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "G8",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "rooms", "role1", "totalCost"),
    label: "Rooms Role 1 Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H8",
    format: "currency",
  },
  // Role 2
  {
    key: path("kpis", "payroll", "rooms", "role2", "name"),
    label: "Rooms Role 2 Name",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "C9",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "rooms", "role2", "fte"),
    label: "Rooms Role 2 FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D9",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "role2", "salaryPerFte"),
    label: "Rooms Role 2 Salary/FTE",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "E9",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "rooms", "role2", "socialCharges"),
    label: "Rooms Role 2 Social Charges %",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "G9",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "rooms", "role2", "totalCost"),
    label: "Rooms Role 2 Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H9",
    format: "currency",
  },
  // Role 3
  {
    key: path("kpis", "payroll", "rooms", "role3", "name"),
    label: "Rooms Role 3 Name",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "C10",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "rooms", "role3", "fte"),
    label: "Rooms Role 3 FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D10",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "role3", "salaryPerFte"),
    label: "Rooms Role 3 Salary/FTE",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "E10",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "rooms", "role3", "socialCharges"),
    label: "Rooms Role 3 Social Charges %",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "G10",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "rooms", "role3", "totalCost"),
    label: "Rooms Role 3 Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H10",
    format: "currency",
  },
  // Role 4
  {
    key: path("kpis", "payroll", "rooms", "role4", "name"),
    label: "Rooms Role 4 Name",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "C11",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "rooms", "role4", "fte"),
    label: "Rooms Role 4 FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D11",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "role4", "salaryPerFte"),
    label: "Rooms Role 4 Salary/FTE",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "E11",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "rooms", "role4", "socialCharges"),
    label: "Rooms Role 4 Social Charges %",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "G11",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "rooms", "role4", "totalCost"),
    label: "Rooms Role 4 Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H11",
    format: "currency",
  },
  // Role 5
  {
    key: path("kpis", "payroll", "rooms", "role5", "name"),
    label: "Rooms Role 5 Name",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "C12",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "rooms", "role5", "fte"),
    label: "Rooms Role 5 FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D12",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "role5", "salaryPerFte"),
    label: "Rooms Role 5 Salary/FTE",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "E12",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "rooms", "role5", "socialCharges"),
    label: "Rooms Role 5 Social Charges %",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "G12",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "rooms", "role5", "totalCost"),
    label: "Rooms Role 5 Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H12",
    format: "currency",
  },
  // Role 6
  {
    key: path("kpis", "payroll", "rooms", "role6", "name"),
    label: "Rooms Role 6 Name",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "C13",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "rooms", "role6", "fte"),
    label: "Rooms Role 6 FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D13",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "role6", "salaryPerFte"),
    label: "Rooms Role 6 Salary/FTE",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "E13",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "rooms", "role6", "socialCharges"),
    label: "Rooms Role 6 Social Charges %",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "G13",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "rooms", "role6", "totalCost"),
    label: "Rooms Role 6 Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H13",
    format: "currency",
  },
  // Role 7
  {
    key: path("kpis", "payroll", "rooms", "role7", "name"),
    label: "Rooms Role 7 Name",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "C14",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "rooms", "role7", "fte"),
    label: "Rooms Role 7 FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D14",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "role7", "salaryPerFte"),
    label: "Rooms Role 7 Salary/FTE",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "E14",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "rooms", "role7", "socialCharges"),
    label: "Rooms Role 7 Social Charges %",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "G14",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "rooms", "role7", "totalCost"),
    label: "Rooms Role 7 Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H14",
    format: "currency",
  },
  // Rooms Totals
  {
    key: path("kpis", "payroll", "rooms", "total", "fte"),
    label: "Rooms Total FTEs",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "D15",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "rooms", "total", "totalCost"),
    label: "Rooms Total Cost",
    section: "Payroll - Rooms",
    sheet: "Payroll Model",
    cell: "H15",
    format: "currency",
  },

  // ========== PAYROLL MODEL - F&B DEPARTMENT ==========
  // Role 1
  {
    key: path("kpis", "payroll", "fnb", "role1", "name"),
    label: "F&B Role 1 Name",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "C18",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "fnb", "role1", "fte"),
    label: "F&B Role 1 FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D18",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "role1", "salaryPerFte"),
    label: "F&B Role 1 Salary/FTE",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "E18",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "fnb", "role1", "socialCharges"),
    label: "F&B Role 1 Social Charges %",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "G18",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "fnb", "role1", "totalCost"),
    label: "F&B Role 1 Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H18",
    format: "currency",
  },
  // Role 2
  {
    key: path("kpis", "payroll", "fnb", "role2", "name"),
    label: "F&B Role 2 Name",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "C19",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "fnb", "role2", "fte"),
    label: "F&B Role 2 FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D19",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "role2", "salaryPerFte"),
    label: "F&B Role 2 Salary/FTE",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "E19",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "fnb", "role2", "socialCharges"),
    label: "F&B Role 2 Social Charges %",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "G19",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "fnb", "role2", "totalCost"),
    label: "F&B Role 2 Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H19",
    format: "currency",
  },
  // Role 3
  {
    key: path("kpis", "payroll", "fnb", "role3", "name"),
    label: "F&B Role 3 Name",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "C20",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "fnb", "role3", "fte"),
    label: "F&B Role 3 FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D20",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "role3", "salaryPerFte"),
    label: "F&B Role 3 Salary/FTE",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "E20",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "fnb", "role3", "socialCharges"),
    label: "F&B Role 3 Social Charges %",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "G20",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "fnb", "role3", "totalCost"),
    label: "F&B Role 3 Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H20",
    format: "currency",
  },
  // Role 4
  {
    key: path("kpis", "payroll", "fnb", "role4", "name"),
    label: "F&B Role 4 Name",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "C21",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "fnb", "role4", "fte"),
    label: "F&B Role 4 FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D21",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "role4", "salaryPerFte"),
    label: "F&B Role 4 Salary/FTE",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "E21",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "fnb", "role4", "socialCharges"),
    label: "F&B Role 4 Social Charges %",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "G21",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "fnb", "role4", "totalCost"),
    label: "F&B Role 4 Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H21",
    format: "currency",
  },
  // Role 5
  {
    key: path("kpis", "payroll", "fnb", "role5", "name"),
    label: "F&B Role 5 Name",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "C22",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "fnb", "role5", "fte"),
    label: "F&B Role 5 FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D22",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "role5", "salaryPerFte"),
    label: "F&B Role 5 Salary/FTE",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "E22",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "fnb", "role5", "socialCharges"),
    label: "F&B Role 5 Social Charges %",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "G22",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "fnb", "role5", "totalCost"),
    label: "F&B Role 5 Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H22",
    format: "currency",
  },
  // Role 6
  {
    key: path("kpis", "payroll", "fnb", "role6", "name"),
    label: "F&B Role 6 Name",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "C23",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "fnb", "role6", "fte"),
    label: "F&B Role 6 FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D23",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "role6", "salaryPerFte"),
    label: "F&B Role 6 Salary/FTE",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "E23",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "fnb", "role6", "socialCharges"),
    label: "F&B Role 6 Social Charges %",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "G23",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "fnb", "role6", "totalCost"),
    label: "F&B Role 6 Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H23",
    format: "currency",
  },
  // Role 7
  {
    key: path("kpis", "payroll", "fnb", "role7", "name"),
    label: "F&B Role 7 Name",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "C24",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "fnb", "role7", "fte"),
    label: "F&B Role 7 FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D24",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "role7", "salaryPerFte"),
    label: "F&B Role 7 Salary/FTE",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "E24",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "fnb", "role7", "socialCharges"),
    label: "F&B Role 7 Social Charges %",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "G24",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "fnb", "role7", "totalCost"),
    label: "F&B Role 7 Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H24",
    format: "currency",
  },
  // F&B Totals
  {
    key: path("kpis", "payroll", "fnb", "total", "fte"),
    label: "F&B Total FTEs",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "D25",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "fnb", "total", "totalCost"),
    label: "F&B Total Cost",
    section: "Payroll - F&B",
    sheet: "Payroll Model",
    cell: "H25",
    format: "currency",
  },

  // ========== PAYROLL MODEL - WELLNESS DEPARTMENT ==========
  // Role 1
  {
    key: path("kpis", "payroll", "wellness", "role1", "name"),
    label: "Wellness Role 1 Name",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "C28",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "wellness", "role1", "fte"),
    label: "Wellness Role 1 FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D28",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "role1", "salaryPerFte"),
    label: "Wellness Role 1 Salary/FTE",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "E28",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "wellness", "role1", "socialCharges"),
    label: "Wellness Role 1 Social Charges %",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "G28",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "wellness", "role1", "totalCost"),
    label: "Wellness Role 1 Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H28",
    format: "currency",
  },
  // Role 2
  {
    key: path("kpis", "payroll", "wellness", "role2", "name"),
    label: "Wellness Role 2 Name",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "C29",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "wellness", "role2", "fte"),
    label: "Wellness Role 2 FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D29",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "role2", "salaryPerFte"),
    label: "Wellness Role 2 Salary/FTE",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "E29",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "wellness", "role2", "socialCharges"),
    label: "Wellness Role 2 Social Charges %",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "G29",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "wellness", "role2", "totalCost"),
    label: "Wellness Role 2 Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H29",
    format: "currency",
  },
  // Role 3
  {
    key: path("kpis", "payroll", "wellness", "role3", "name"),
    label: "Wellness Role 3 Name",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "C30",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "wellness", "role3", "fte"),
    label: "Wellness Role 3 FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D30",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "role3", "salaryPerFte"),
    label: "Wellness Role 3 Salary/FTE",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "E30",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "wellness", "role3", "socialCharges"),
    label: "Wellness Role 3 Social Charges %",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "G30",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "wellness", "role3", "totalCost"),
    label: "Wellness Role 3 Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H30",
    format: "currency",
  },
  // Role 4
  {
    key: path("kpis", "payroll", "wellness", "role4", "name"),
    label: "Wellness Role 4 Name",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "C31",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "wellness", "role4", "fte"),
    label: "Wellness Role 4 FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D31",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "role4", "salaryPerFte"),
    label: "Wellness Role 4 Salary/FTE",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "E31",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "wellness", "role4", "socialCharges"),
    label: "Wellness Role 4 Social Charges %",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "G31",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "wellness", "role4", "totalCost"),
    label: "Wellness Role 4 Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H31",
    format: "currency",
  },
  // Role 5
  {
    key: path("kpis", "payroll", "wellness", "role5", "name"),
    label: "Wellness Role 5 Name",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "C32",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "wellness", "role5", "fte"),
    label: "Wellness Role 5 FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D32",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "role5", "salaryPerFte"),
    label: "Wellness Role 5 Salary/FTE",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "E32",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "wellness", "role5", "socialCharges"),
    label: "Wellness Role 5 Social Charges %",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "G32",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "wellness", "role5", "totalCost"),
    label: "Wellness Role 5 Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H32",
    format: "currency",
  },
  // Role 6
  {
    key: path("kpis", "payroll", "wellness", "role6", "name"),
    label: "Wellness Role 6 Name",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "C33",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "wellness", "role6", "fte"),
    label: "Wellness Role 6 FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D33",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "role6", "salaryPerFte"),
    label: "Wellness Role 6 Salary/FTE",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "E33",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "wellness", "role6", "socialCharges"),
    label: "Wellness Role 6 Social Charges %",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "G33",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "wellness", "role6", "totalCost"),
    label: "Wellness Role 6 Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H33",
    format: "currency",
  },
  // Role 7
  {
    key: path("kpis", "payroll", "wellness", "role7", "name"),
    label: "Wellness Role 7 Name",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "C34",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "wellness", "role7", "fte"),
    label: "Wellness Role 7 FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D34",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "role7", "salaryPerFte"),
    label: "Wellness Role 7 Salary/FTE",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "E34",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "wellness", "role7", "socialCharges"),
    label: "Wellness Role 7 Social Charges %",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "G34",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "wellness", "role7", "totalCost"),
    label: "Wellness Role 7 Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H34",
    format: "currency",
  },
  // Wellness Totals
  {
    key: path("kpis", "payroll", "wellness", "total", "fte"),
    label: "Wellness Total FTEs",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "D35",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "wellness", "total", "totalCost"),
    label: "Wellness Total Cost",
    section: "Payroll - Wellness",
    sheet: "Payroll Model",
    cell: "H35",
    format: "currency",
  },

  // ========== PAYROLL MODEL - A&G DEPARTMENT ==========
  // Role 1
  {
    key: path("kpis", "payroll", "ag", "role1", "name"),
    label: "A&G Role 1 Name",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "C38",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "ag", "role1", "fte"),
    label: "A&G Role 1 FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D38",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "role1", "salaryPerFte"),
    label: "A&G Role 1 Salary/FTE",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "E38",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "ag", "role1", "socialCharges"),
    label: "A&G Role 1 Social Charges %",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "G38",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "ag", "role1", "totalCost"),
    label: "A&G Role 1 Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H38",
    format: "currency",
  },
  // Role 2
  {
    key: path("kpis", "payroll", "ag", "role2", "name"),
    label: "A&G Role 2 Name",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "C39",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "ag", "role2", "fte"),
    label: "A&G Role 2 FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D39",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "role2", "salaryPerFte"),
    label: "A&G Role 2 Salary/FTE",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "E39",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "ag", "role2", "socialCharges"),
    label: "A&G Role 2 Social Charges %",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "G39",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "ag", "role2", "totalCost"),
    label: "A&G Role 2 Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H39",
    format: "currency",
  },
  // Role 3
  {
    key: path("kpis", "payroll", "ag", "role3", "name"),
    label: "A&G Role 3 Name",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "C40",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "ag", "role3", "fte"),
    label: "A&G Role 3 FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D40",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "role3", "salaryPerFte"),
    label: "A&G Role 3 Salary/FTE",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "E40",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "ag", "role3", "socialCharges"),
    label: "A&G Role 3 Social Charges %",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "G40",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "ag", "role3", "totalCost"),
    label: "A&G Role 3 Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H40",
    format: "currency",
  },
  // Role 4
  {
    key: path("kpis", "payroll", "ag", "role4", "name"),
    label: "A&G Role 4 Name",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "C41",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "ag", "role4", "fte"),
    label: "A&G Role 4 FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D41",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "role4", "salaryPerFte"),
    label: "A&G Role 4 Salary/FTE",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "E41",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "ag", "role4", "socialCharges"),
    label: "A&G Role 4 Social Charges %",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "G41",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "ag", "role4", "totalCost"),
    label: "A&G Role 4 Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H41",
    format: "currency",
  },
  // Role 5
  {
    key: path("kpis", "payroll", "ag", "role5", "name"),
    label: "A&G Role 5 Name",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "C42",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "ag", "role5", "fte"),
    label: "A&G Role 5 FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D42",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "role5", "salaryPerFte"),
    label: "A&G Role 5 Salary/FTE",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "E42",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "ag", "role5", "socialCharges"),
    label: "A&G Role 5 Social Charges %",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "G42",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "ag", "role5", "totalCost"),
    label: "A&G Role 5 Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H42",
    format: "currency",
  },
  // Role 6
  {
    key: path("kpis", "payroll", "ag", "role6", "name"),
    label: "A&G Role 6 Name",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "C43",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "ag", "role6", "fte"),
    label: "A&G Role 6 FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D43",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "role6", "salaryPerFte"),
    label: "A&G Role 6 Salary/FTE",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "E43",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "ag", "role6", "socialCharges"),
    label: "A&G Role 6 Social Charges %",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "G43",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "ag", "role6", "totalCost"),
    label: "A&G Role 6 Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H43",
    format: "currency",
  },
  // Role 7
  {
    key: path("kpis", "payroll", "ag", "role7", "name"),
    label: "A&G Role 7 Name",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "C44",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "ag", "role7", "fte"),
    label: "A&G Role 7 FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D44",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "role7", "salaryPerFte"),
    label: "A&G Role 7 Salary/FTE",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "E44",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "ag", "role7", "socialCharges"),
    label: "A&G Role 7 Social Charges %",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "G44",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "ag", "role7", "totalCost"),
    label: "A&G Role 7 Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H44",
    format: "currency",
  },
  // A&G Totals
  {
    key: path("kpis", "payroll", "ag", "total", "fte"),
    label: "A&G Total FTEs",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "D45",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "ag", "total", "totalCost"),
    label: "A&G Total Cost",
    section: "Payroll - A&G",
    sheet: "Payroll Model",
    cell: "H45",
    format: "currency",
  },

  // ========== PAYROLL MODEL - SALES & MARKETING DEPARTMENT ==========
  // Role 1
  {
    key: path("kpis", "payroll", "sales", "role1", "name"),
    label: "Sales & Marketing Role 1 Name",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "C48",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "sales", "role1", "fte"),
    label: "Sales & Marketing Role 1 FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D48",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "role1", "salaryPerFte"),
    label: "Sales & Marketing Role 1 Salary/FTE",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "E48",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "sales", "role1", "socialCharges"),
    label: "Sales & Marketing Role 1 Social Charges %",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "G48",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "sales", "role1", "totalCost"),
    label: "Sales & Marketing Role 1 Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H48",
    format: "currency",
  },
  // Role 2
  {
    key: path("kpis", "payroll", "sales", "role2", "name"),
    label: "Sales & Marketing Role 2 Name",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "C49",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "sales", "role2", "fte"),
    label: "Sales & Marketing Role 2 FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D49",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "role2", "salaryPerFte"),
    label: "Sales & Marketing Role 2 Salary/FTE",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "E49",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "sales", "role2", "socialCharges"),
    label: "Sales & Marketing Role 2 Social Charges %",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "G49",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "sales", "role2", "totalCost"),
    label: "Sales & Marketing Role 2 Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H49",
    format: "currency",
  },
  // Role 3
  {
    key: path("kpis", "payroll", "sales", "role3", "name"),
    label: "Sales & Marketing Role 3 Name",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "C50",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "sales", "role3", "fte"),
    label: "Sales & Marketing Role 3 FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D50",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "role3", "salaryPerFte"),
    label: "Sales & Marketing Role 3 Salary/FTE",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "E50",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "sales", "role3", "socialCharges"),
    label: "Sales & Marketing Role 3 Social Charges %",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "G50",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "sales", "role3", "totalCost"),
    label: "Sales & Marketing Role 3 Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H50",
    format: "currency",
  },
  // Role 4
  {
    key: path("kpis", "payroll", "sales", "role4", "name"),
    label: "Sales & Marketing Role 4 Name",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "C51",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "sales", "role4", "fte"),
    label: "Sales & Marketing Role 4 FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D51",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "role4", "salaryPerFte"),
    label: "Sales & Marketing Role 4 Salary/FTE",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "E51",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "sales", "role4", "socialCharges"),
    label: "Sales & Marketing Role 4 Social Charges %",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "G51",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "sales", "role4", "totalCost"),
    label: "Sales & Marketing Role 4 Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H51",
    format: "currency",
  },
  // Role 5
  {
    key: path("kpis", "payroll", "sales", "role5", "name"),
    label: "Sales & Marketing Role 5 Name",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "C52",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "sales", "role5", "fte"),
    label: "Sales & Marketing Role 5 FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D52",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "role5", "salaryPerFte"),
    label: "Sales & Marketing Role 5 Salary/FTE",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "E52",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "sales", "role5", "socialCharges"),
    label: "Sales & Marketing Role 5 Social Charges %",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "G52",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "sales", "role5", "totalCost"),
    label: "Sales & Marketing Role 5 Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H52",
    format: "currency",
  },
  // Role 6
  {
    key: path("kpis", "payroll", "sales", "role6", "name"),
    label: "Sales & Marketing Role 6 Name",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "C53",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "sales", "role6", "fte"),
    label: "Sales & Marketing Role 6 FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D53",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "role6", "salaryPerFte"),
    label: "Sales & Marketing Role 6 Salary/FTE",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "E53",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "sales", "role6", "socialCharges"),
    label: "Sales & Marketing Role 6 Social Charges %",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "G53",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "sales", "role6", "totalCost"),
    label: "Sales & Marketing Role 6 Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H53",
    format: "currency",
  },
  // Role 7
  {
    key: path("kpis", "payroll", "sales", "role7", "name"),
    label: "Sales & Marketing Role 7 Name",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "C54",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "sales", "role7", "fte"),
    label: "Sales & Marketing Role 7 FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D54",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "role7", "salaryPerFte"),
    label: "Sales & Marketing Role 7 Salary/FTE",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "E54",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "sales", "role7", "socialCharges"),
    label: "Sales & Marketing Role 7 Social Charges %",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "G54",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "sales", "role7", "totalCost"),
    label: "Sales & Marketing Role 7 Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H54",
    format: "currency",
  },
  // Sales & Marketing Totals
  {
    key: path("kpis", "payroll", "sales", "total", "fte"),
    label: "Sales & Marketing Total FTEs",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "D55",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "sales", "total", "totalCost"),
    label: "Sales & Marketing Total Cost",
    section: "Payroll - Sales",
    sheet: "Payroll Model",
    cell: "H55",
    format: "currency",
  },

  // ========== PAYROLL MODEL - MAINTENANCE DEPARTMENT ==========
  // Role 1
  {
    key: path("kpis", "payroll", "maintenance", "role1", "name"),
    label: "Maintenance Role 1 Name",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "C58",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role1", "fte"),
    label: "Maintenance Role 1 FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D58",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role1", "salaryPerFte"),
    label: "Maintenance Role 1 Salary/FTE",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "E58",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role1", "socialCharges"),
    label: "Maintenance Role 1 Social Charges %",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "G58",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role1", "totalCost"),
    label: "Maintenance Role 1 Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H58",
    format: "currency",
  },
  // Role 2
  {
    key: path("kpis", "payroll", "maintenance", "role2", "name"),
    label: "Maintenance Role 2 Name",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "C59",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role2", "fte"),
    label: "Maintenance Role 2 FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D59",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role2", "salaryPerFte"),
    label: "Maintenance Role 2 Salary/FTE",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "E59",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role2", "socialCharges"),
    label: "Maintenance Role 2 Social Charges %",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "G59",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role2", "totalCost"),
    label: "Maintenance Role 2 Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H59",
    format: "currency",
  },
  // Role 3
  {
    key: path("kpis", "payroll", "maintenance", "role3", "name"),
    label: "Maintenance Role 3 Name",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "C60",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role3", "fte"),
    label: "Maintenance Role 3 FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D60",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role3", "salaryPerFte"),
    label: "Maintenance Role 3 Salary/FTE",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "E60",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role3", "socialCharges"),
    label: "Maintenance Role 3 Social Charges %",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "G60",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role3", "totalCost"),
    label: "Maintenance Role 3 Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H60",
    format: "currency",
  },
  // Role 4
  {
    key: path("kpis", "payroll", "maintenance", "role4", "name"),
    label: "Maintenance Role 4 Name",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "C61",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role4", "fte"),
    label: "Maintenance Role 4 FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D61",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role4", "salaryPerFte"),
    label: "Maintenance Role 4 Salary/FTE",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "E61",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role4", "socialCharges"),
    label: "Maintenance Role 4 Social Charges %",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "G61",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role4", "totalCost"),
    label: "Maintenance Role 4 Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H61",
    format: "currency",
  },
  // Role 5
  {
    key: path("kpis", "payroll", "maintenance", "role5", "name"),
    label: "Maintenance Role 5 Name",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "C62",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role5", "fte"),
    label: "Maintenance Role 5 FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D62",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role5", "salaryPerFte"),
    label: "Maintenance Role 5 Salary/FTE",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "E62",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role5", "socialCharges"),
    label: "Maintenance Role 5 Social Charges %",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "G62",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role5", "totalCost"),
    label: "Maintenance Role 5 Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H62",
    format: "currency",
  },
  // Role 6
  {
    key: path("kpis", "payroll", "maintenance", "role6", "name"),
    label: "Maintenance Role 6 Name",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "C63",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role6", "fte"),
    label: "Maintenance Role 6 FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D63",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role6", "salaryPerFte"),
    label: "Maintenance Role 6 Salary/FTE",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "E63",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role6", "socialCharges"),
    label: "Maintenance Role 6 Social Charges %",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "G63",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role6", "totalCost"),
    label: "Maintenance Role 6 Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H63",
    format: "currency",
  },
  // Role 7
  {
    key: path("kpis", "payroll", "maintenance", "role7", "name"),
    label: "Maintenance Role 7 Name",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "C64",
    format: "text",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role7", "fte"),
    label: "Maintenance Role 7 FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D64",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role7", "salaryPerFte"),
    label: "Maintenance Role 7 Salary/FTE",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "E64",
    format: "currency",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role7", "socialCharges"),
    label: "Maintenance Role 7 Social Charges %",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "G64",
    format: "percent",
  },
  {
    key: path("kpis", "payroll", "maintenance", "role7", "totalCost"),
    label: "Maintenance Role 7 Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H64",
    format: "currency",
  },
  // Maintenance Totals
  {
    key: path("kpis", "payroll", "maintenance", "total", "fte"),
    label: "Maintenance Total FTEs",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "D65",
    format: "number",
  },
  {
    key: path("kpis", "payroll", "maintenance", "total", "totalCost"),
    label: "Maintenance Total Cost",
    section: "Payroll - Maintenance",
    sheet: "Payroll Model",
    cell: "H65",
    format: "currency",
  },

  // ========== OPERATING COSTS ==========
  {
    key: path("kpis", "opex", "roomsCommission"),
    label: "Rooms Commission",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D4",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "guestSuppliesCleaning"),
    label: "Guest Supplies & Cleaning",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D5",
    format: "currency",
  },
  {
    key: path("kpis", "opex", "cogs"),
    label: "Cost of Goods Sold (F&B)",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D6",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "meetingsEvents"),
    label: "Meeting & Events",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D7",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "wellnessOther"),
    label: "Wellness & Other",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D8",
    format: "currency",
  },
  {
    key: path("kpis", "opex", "otherDirect"),
    label: "Other Direct",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D9",
    format: "currency",
  },
  {
    key: path("kpis", "opex", "adminGeneralOther"),
    label: "Admin & General Other",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D12",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "techSubscriptions"),
    label: "Tech Subscriptions",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D13",
    format: "currency",
  },
  {
    key: path("kpis", "opex", "salesMarketingOther"),
    label: "Sales & Marketing Other",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D14",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "maintenanceOther"),
    label: "Maintenance Other",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D15",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "utilities"),
    label: "Utilities",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D16",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "mgmtFee"),
    label: "Management Fee",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D19",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "propertyTaxes"),
    label: "Property Taxes",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D20",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "insurance"),
    label: "Insurance",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D21",
    format: "percent",
  },
  {
    key: path("kpis", "opex", "rent"),
    label: "Rent",
    section: "Operating Costs",
    sheet: "Operating Costs",
    cell: "D22",
    format: "currency",
  },

  // ========== RAMP & MACRO ==========
  {
    key: path("kpis", "rampSettings", "revenueRamp", "0"),
    label: "Revenue Ramp Y1",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "C5",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "revenueRamp", "1"),
    label: "Revenue Ramp Y2",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "D5",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "revenueRamp", "2"),
    label: "Revenue Ramp Y3",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "E5",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "revenueRamp", "3"),
    label: "Revenue Ramp Y4",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "F5",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "costRamp", "0"),
    label: "Cost Ramp Y1",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "C9",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "costRamp", "1"),
    label: "Cost Ramp Y2",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "D9",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "costRamp", "2"),
    label: "Cost Ramp Y3",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "E9",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "costRamp", "3"),
    label: "Cost Ramp Y4",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "F9",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "toplineGrowthPct"),
    label: "Topline Growth / Yr",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "E12",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "inflationPct"),
    label: "Inflation / Yr",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "E13",
    format: "percent",
  },
  {
    key: path("kpis", "rampSettings", "depreciationPctOfCapex"),
    label: "Depreciation %",
    section: "Ramp & Macro",
    sheet: "Ramp & Macro",
    cell: "E14",
    format: "percent",
  },

  // ========== FINANCING ==========
  {
    key: path("kpis", "financing", "ltcPct"),
    label: "LTC Ratio",
    section: "Financing",
    sheet: "Financing",
    cell: "D3",
    format: "percent",
  },
  {
    key: path("kpis", "financing", "interestRatePct"),
    label: "Interest Rate",
    section: "Financing",
    sheet: "Financing",
    cell: "D9",
    format: "percent",
  },
  {
    key: path("kpis", "financing", "amortYears"),
    label: "Amortization (Years)",
    section: "Financing",
    sheet: "Financing",
    cell: "D10",
    format: "number",
  },
  {
    key: path("kpis", "financing", "taxRateOnEBT"),
    label: "Tax Rate on EBT",
    section: "Financing",
    sheet: "Financing",
    cell: "D12",
    format: "percent",
  },

  // ========== EXIT STRATEGY ==========
  {
    key: path("kpis", "exit", "holdPeriodYears"),
    label: "Exit Year",
    section: "Exit Strategy",
    sheet: "Exit Strategy",
    cell: "D3",
    format: "number",
  },
  {
    key: path("kpis", "exit", "exitCapRate"),
    label: "Exit Cap Rate",
    section: "Exit Strategy",
    sheet: "Exit Strategy",
    cell: "D4",
    format: "percent",
  },
  {
    key: path("kpis", "exit", "sellingCostsPct"),
    label: "Selling Costs",
    section: "Exit Strategy",
    sheet: "Exit Strategy",
    cell: "D5",
    format: "percent",
  },
];

export const FULL_OUTPUT_MAPPING: OutputDefinition[] = [
  {
    key: path("kpis", "exit", "estimatedReturns", "developmentProfit"),
    label: "Development Profit",
    sheet: "PL",
    cell: "G62",
    format: "currency",
  },
  {
    key: path("kpis", "exit", "estimatedReturns", "irrUnlevered"),
    label: "Unlevered IRR",
    sheet: "Cashflow",
    cell: "E11",
    format: "percent",
  },
  {
    key: path("kpis", "exit", "estimatedReturns", "irrLevered"),
    label: "Levered IRR",
    sheet: "Cashflow",
    cell: "E19",
    format: "percent",
  },
  {
    key: path("kpis", "avgADR"),
    label: "Average ADR",
    sheet: "PL",
    cell: "D69",
    format: "currency",
  },
  {
    key: path("kpis", "avgOccupancy"),
    label: "Average Occupancy",
    sheet: "PL",
    cell: "D70",
    format: "percent",
  },
  {
    key: path("kpis", "avgRevPAR"),
    label: "Average RevPAR",
    sheet: "PL",
    cell: "D71",
    format: "currency",
  },
];
